<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(fab dark small v-on="on")
        v-icon(dark) mdi-upload
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{translations.multicreate.title}}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        h5 {{translations.multicreate.helpText}}
        ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
          v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4
            v-container(fluid)
              v-row
                v-col(cols="12" sm="6")
                  BaseSelectField(rules="required" label="Provider" v-model="form.provider", :items="providersList")
                v-col(cols="12" sm="6").text-md-right
                  ValidationProvider(rules="required" v-slot="{ errors }")
                    v-file-input(
                      accept=".csv"
                      show-size
                      :error="errors.length > 0"
                      @change="onFileChange"
                      v-model="file")
                      template(v-slot:label)
                        v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                        | {{ translations.multicreate.fileInput }}
                    span.red--text.text--accent-2(v-if="errors.length > 0")
                      v-icon(color="red accent-2") mdi-alert
                      |  {{ errors[0] }}
                    p.red--text(v-if="rowsToInsertCount > 0") {{translations.multicreate.loadedGamesText}} {{rowsToInsertCount}} {{translations.multicreate.game}}.
                v-col.pa-2.pa-md-6(cols="12")
                  BaseConfirmDialog(v-bind="translations.confirmationDialog.status"  @confirm="submitMulticreate" )
                    template(v-slot="{ on }")
                      v-btn.float-right.big(:disabled="submitDisabled"
                        v-on="on"
                        color="primary"
                        ) {{translations.buttons.create}}

</template>

<script>

  export default {
    name: "GameMultiCreateDialog",
    props: {
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      providersList:{
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      dialog: false,
      submitDisabled: true,
      rowsToInsertCount: 0,
      file: null,
      form: {
        provider: '',
        games: [],
      },
    }),
    computed: {
      loadingCreate() {
        return this.$store.state.statusCode.multiCreateGame.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.multiCreateGame.state;
      },
    },
    watch: {
      dialog: function(val){
        if(val) {
          if(this.$refs.validator) {
            this.clearFields();
            this.$refs.validator.reset();
          }
        }
      },
      stateCreate: function(val){
        if (val == 200 && this.dialog){
          this.dialog = false;
          this.$emit('successCreate');
        }
      },
    },
    methods: {
      onFileChange() {
        if(this.file != undefined){
          let reader  = new FileReader();
          reader.readAsText(this.file);
          reader.addEventListener('load', () => {
            let gameList = this.csvJSON(reader.result);
            this.form.games = gameList;
            this.rowsToInsertCount = gameList.length;
            this.submitDisabled = false;
          }, false)
        } else {
          this.form.games = [];
          this.rowsToInsertCount = 0;
          this.submitDisabled = true;
        }
      },
      csvJSON(csv){
        let lines = csv.split('\n');
        let result = [];
        let headers = lines[0].split(';');
        lines.splice(0, 1);
        lines.forEach(function(line) {
          let obj = {};
          let currentline = line.split(';');
          headers.forEach(function(header, i) {
             obj[header] = currentline[i];
          });
          result.push(obj);
        });
        return result;
      },
      submitMulticreate(){
        this.$store.dispatch('multiCreateGame',this.form);
      },
      clearFields(){
        this.form.provider = '';
        this.form.file = null;
        this.form.games = [];
        this.rowsToInsertCount = 0;
        this.submitDisabled = true;
      }
    }
  }
</script>

<style lang="sass">
</style>